module.exports = __webpack_public_path__ + "static/media/fast.e2171c03.png";